import { render } from "./Label.vue?vue&type=template&id=5f114f72"
const script = {}

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Filters/Support/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f114f72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f114f72', __exports__)) {
    api.reload('5f114f72', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=5f114f72", () => {
    api.rerender('5f114f72', render)
  })

}


export default __exports__